import { bl_aat_engagement_employee_link_RowClass } from '../../../dbschema/bl_aat_engagement_employee_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementEmployeeLinkContainerModel extends BaseContainerModel {
    bl_aat_engagement_employee_link: bl_aat_engagement_employee_link_RowClass = new bl_aat_engagement_employee_link_RowClass();
}